/** Kurátorovaná paleta barev tabulek — validovaná pro light i dark mód (E6-US3). */
export const COLOR_TOKENS = [
    'slate',
    'red',
    'orange',
    'amber',
    'green',
    'teal',
    'blue',
    'indigo',
    'violet',
    'pink',
];
export function isColorToken(value) {
    return typeof value === 'string' && COLOR_TOKENS.includes(value);
}
/** Výchozí (nikdy ručně neupravená) trasa — vrací se i pro FK bez záznamu v `edgeRoutes`. */
export function defaultEdgeRoute() {
    return { waypoints: [], isManuallyRouted: false };
}
/**
 * `canvas.edgeRoutes` je nepovinné i v typu jen kvůli obraně proti starším
 * lokálním projektovým souborům bez tohoto pole (žádný migrační mechanismus
 * nad rámec `formatVersion` guardu neexistuje) — nový záznam se vždy ukládá
 * explicitně, `??` tu řeší jen čtení dat uložených před Epic 7.
 */
export function getEdgeRoute(canvas, foreignKeyId) {
    return canvas.edgeRoutes?.[foreignKeyId] ?? defaultEdgeRoute();
}
/**
 * Dohledá cílovou tabulku každé FK vazby podle názvu — `ForeignKeyModel`
 * nenese ID cílové tabulky, jen `referencedSchema`/`referencedTable` (Epic 1
 * kap. 6). Nerozřešitelné vazby se nevyhazují jako chyba, jen se označí
 * `targetTableId: null`, aby je volající mohl bezpečně přeskočit.
 */
export function resolveForeignKeyEdges(schema) {
    const edges = [];
    for (const table of schema.tables) {
        for (const foreignKey of table.foreignKeys) {
            const target = schema.tables.find((candidate) => candidate.schema === foreignKey.referencedSchema &&
                candidate.name === foreignKey.referencedTable);
            edges.push({
                foreignKey,
                sourceTableId: table.id,
                targetTableId: target?.id ?? null,
            });
        }
    }
    return edges;
}
//# sourceMappingURL=canvas.js.map